import { useEffect } from 'react';

/**
 * Component to initialize developer tools with supabase client from CustomerContext
 * This ensures the developer tools have access to the authenticated supabase client
 * NOTE: DevTools are initialized in App.js useEffect - this component is a no-op guard
 */
const DevToolsInitializer = () => {
  useEffect(() => {
    // Guard: Only initialize in development and if not already initialized
    if (process.env.NODE_ENV !== 'development') return;
    if (window.__DEVTOOLS_INITIALIZED__) return;
    
    window.__DEVTOOLS_INITIALIZED__ = true;
    // DevTools are initialized in App.js - this is a secondary guard
  }, []);

  // This component doesn't render anything
  return null;
};

export default DevToolsInitializer;
